/* eslint-disable react-hooks/exhaustive-deps */
import Constant from '@/common/constant/Constant';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import MuiDateTimePicker from '../../common/form/datetime-picker';
import Utils from '@/common/utils/utils';
import { Button, Tooltip } from '@material-ui/core';
import { useEffect, useState } from 'react';
import RenderTooltipTitles from './RenderTooltipTitles';
import { PropTypes } from 'prop-types';
import moment from 'moment';

DataPickerInput.propTypes = {
    defaultValue: PropTypes.any,
    clearErrors: PropTypes.any,
    name: PropTypes.any,
    data: PropTypes.any,
    triggerValidate: PropTypes.any,
    detailTicket: PropTypes.any,
    setValue: PropTypes.any,
    setOnChangeEdit: PropTypes.any,
    onChangeEdit: PropTypes.any,
    setShowButtonEditTicket: PropTypes.any,
    errorlist: PropTypes.any,
    getValues: PropTypes.func,
    pairedEndFieldId: PropTypes.string,
};

export default function DataPickerInput(props) {
    const defaultValue = props?.defaultValue || '';
    const [value, setValue] = useState(defaultValue);

    let dateFormat = props.data.structure.dateFormat;
    if(props.data?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.DURATION){
        dateFormat = Constant.SETTING_DATE_FIELD_FORMAT.HHMMSS;
    }
    const isAddTicket = !props?.detailTicket || false;

    const pickerConfig = {
        [Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM]: {
            typePicker: Constant.COMPONENT_DATETIME_PICKER.DATE_TIME_PICKER,
            format: Constant.MOMENT_DATE_FORMAT.YYYYMMDD_HHMM,
            showClearButton: true,
            useValueAsDefault: false
        },
        [Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD]: {
            typePicker: Constant.COMPONENT_DATETIME_PICKER.DATE_PICKER,
            format: Constant.MOMENT_DATE_FORMAT.YYYYMMDD,
            showClearButton: true,
            useValueAsDefault: false
        },
        [Constant.SETTING_DATE_FIELD_FORMAT.YYYYMM]: {
            typePicker: Constant.COMPONENT_DATETIME_PICKER.DATE_PICKER,
            format: Constant.MOMENT_DATE_FORMAT.YYYYMM,
            views: [Constant.VIEW_DATE_PICKER.YEAR, Constant.VIEW_DATE_PICKER.MONTH],
            showClearButton: true,
            useValueAsDefault: false
        },
        [Constant.SETTING_DATE_FIELD_FORMAT.YYYY]: {
            typePicker: Constant.COMPONENT_DATETIME_PICKER.DATE_PICKER,
            format: Constant.MOMENT_DATE_FORMAT.YYYY,
            views: [Constant.VIEW_DATE_PICKER.YEAR],
            showClearButton: true,
            useValueAsDefault: false
        },
        [Constant.SETTING_DATE_FIELD_FORMAT.HHMM]: {
            typePicker: Constant.COMPONENT_DATETIME_PICKER.TIME_PICKER,
            format: Constant.MOMENT_DATE_FORMAT.HHMM,
            showClearButton: true,
            useValueAsDefault: false
        },
        [Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMMSS]: {
            typePicker: Constant.COMPONENT_DATETIME_PICKER.DATE_TIME_PICKER,
            format: Constant.MOMENT_DATE_FORMAT.YYYYMMDD_HHMMSS,
            showClearButton: false,
            useValueAsDefault: false
        },
        [Constant.SETTING_DATE_FIELD_FORMAT.HHMMSS]: {
            typePicker: Constant.COMPONENT_DATETIME_PICKER.TIME_PICKER,
            format: Constant.MOMENT_DATE_FORMAT.HHMMSS,
            showClearButton: false,
            useValueAsDefault: false
        }
    };

    // Default config
    const defaultConfig = {
        typePicker: Constant.COMPONENT_DATETIME_PICKER.DATE_TIME_PICKER,
        format: Constant.MOMENT_DATE_FORMAT.YYYYMMDD_HHMM,
        showClearButton: true,
        useValueAsDefault: true
    };

    const getDateByFormat = (dateValue, format) => {
        if (moment.isMoment(dateValue)) {
            // keep the original date value even if the format is invalid when onchange
            if (!dateValue.isValid()) {
                return dateValue._i || '';
            }
        }
        let dateByFormat = '';
        switch (format) {
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM:
                dateByFormat = dateValue.format(Constant.MOMENT_DATE_FORMAT.YYYYMMDD_HHMM);
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD:
                dateByFormat = dateValue.format(Constant.MOMENT_DATE_FORMAT.YYYYMMDD);
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMM:
                dateByFormat = dateValue.format(Constant.MOMENT_DATE_FORMAT.YYYYMM);
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYY:
                dateByFormat = dateValue.format(Constant.MOMENT_DATE_FORMAT.YYYY);
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.HHMM:
                dateByFormat = dateValue.format(Constant.MOMENT_DATE_FORMAT.HHMM);
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMMSS:
                dateByFormat = dateValue.format(Constant.MOMENT_DATE_FORMAT.YYYYMMDD_HHMMSS);
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.HHMMSS:
                dateByFormat = dateValue.format(Constant.MOMENT_DATE_FORMAT.HHMMSS);
                break;
            default:
                dateByFormat = dateValue.format(Constant.MOMENT_DATE_FORMAT.YYYYMMDD_HHMM);
        }
        return dateByFormat;
    };

    const onChangeDate = (dateValue, format) => {
        props.clearErrors(props?.name);

        let dateByFormat = dateValue ? getDateByFormat(dateValue, format) : '';

        setValue(dateValue);
        props.setValue(props?.name, dateByFormat);

        // Auto-adjust end_date when start_date > end_date for AI Telephone date fields
        const sysField = props?.data?.sysField;
        if (
            sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE &&
            props?.pairedEndFieldId &&
            dateValue &&
            props?.getValues
        ) {
            const endDateValue = props.getValues(props.pairedEndFieldId);
            if (endDateValue) {
                const startMoment = moment.isMoment(dateValue) ? dateValue : moment(dateValue, format);
                const endMoment = moment(endDateValue, format);

                if (startMoment.isValid() && endMoment.isValid() && startMoment.isAfter(endMoment)) {
                    props.setValue(props.pairedEndFieldId, dateByFormat);
                }
            }
        }

        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket()
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
        }
    };

    const onBlurValidateDate = (fieldName) => {
        if (props.triggerValidate) {
            props.triggerValidate(fieldName)
        }
    }

    const handleCloseDatePicker = () => {
        setValue(null);
        props.setValue(props?.name, '');
        if (props?.setIsEdited) {
            if (props?.setOnChangeEdit) {
                props?.setOnChangeEdit(!props.onChangeEdit);
            }
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            if (!props?.listFieldEdited?.includes(props?.name)) {
                props?.setListFieldEdited([...props.listFieldEdited, props?.name]);
            }
        }
    }

    useEffect(() => {
        props.register(props?.name);
        props.setValue(props?.name, props?.defaultValue ? props?.defaultValue : '');
    }, [props?.defaultValue]);

    useEffect(() => {
        setValue(props.defaultValue ? props.defaultValue: null)
    },[props?.triggerReloadTicket])

    useEffect(() => {
        if (isAddTicket) {
            props.register(props?.name, {
                onChange: e => {}
            });
        
            setValue(defaultValue || null)
            props.setValue(props?.name, defaultValue || '');
        }
        let isKnowledgeForm = [Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(props?.parentForm?.type);
        if (props?.isDraftMode || (props?.editTicket && !isKnowledgeForm)) {
            props.register(props?.name, {
                onChange: e => {}
            });
        
            setValue(defaultValue || null)
            props.setValue(props?.name, defaultValue || '');
        }
    }, [props?.parentForm]);

    const isDisableField = () => {
        return (
            props.data.structure.publicForCustomer == 2 ||
            props.viewFromProjectOfEscalateTicket ||
            !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
            props.hasEditFieldPermissions === false
        );
    };

    useEffect(() => {
        if (props?.flagReset) {
            props?.setValue(props?.name, props?.defaultValue || null);
            if (dateFormat === Constant.SETTING_DATE_FIELD_FORMAT.HHMM) {
                setValue(Utils.parseDate({ value: props?.defaultValue, format: 'HH:mm' }));
            } else {
                setValue(props?.defaultValue || null);
            }
            props.setFlagReset(false);
        }
    }, [props?.flagReset, props?.defaultValue, props?.name]);

    const getComponentPicker = () => {
        const config = pickerConfig[dateFormat] || defaultConfig;

        const isPickerDisabled = () => {
            return (
                props.data.structure.publicForCustomer === 
                    Constant.SETTING_FORM_DEFAULT.READ_ONLY ||
                props.viewFromProjectOfEscalateTicket ||
                !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
                props.hasEditFieldPermissions === false
            );
        };

        const shouldHideIcon = () => {
            // Only hide icon for telephone_duration field
            return (
                props.data?.sysField === 
                    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.DURATION
            );
        };

        const renderClearButton = () => {
            if (!config?.showClearButton) return null;

            if (props.hasEditFieldPermissions && !isDisableField()) {
                return (
                    <Button
                        disabled={isDisableField()}
                        className="close-DatePicker"
                        onClick={handleCloseDatePicker}
                    >
                        <img src={Constant.ICON_CLOSE_DATETIME} alt="" />
                    </Button>
                );
            }
            return null;
        };

        const hideIconClass = shouldHideIcon() ? 'hide-date-picker-icon' : '';
        
        return (
            <div className={`itemDatePicker ${hideIconClass}`}>
                <MuiDateTimePicker
                    className="field-date-picker form-control-wrapPicker form-control-hg40"
                    name={props.name}
                    defaultValue={config?.useValueAsDefault ? value : defaultValue}
                    value={value}
                    typePicker={config?.typePicker}
                    format={config?.format}
                    {...(config?.views && { views: config?.views })}
                    ampm={false}
                    disabled={isPickerDisabled() || config?.disabled}
                    onChange={e => onChangeDate(e, dateFormat)}
                    onBlur={e => onBlurValidateDate(props.name)}
                    errorlist={props.errorlist}
                    hideIcon={shouldHideIcon()}
                />
                {renderClearButton()}
            </div>
        );
    };

    const getWrapperClassName = () => {
        const sysField = props.data?.sysField;
        const ticketMetaData = Utils.convertJSONDataToObject(props?.detailTicket?.metaData);

        const classConditions = [
            {
                condition: sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.START_TIME,
                className: 'width-50-left'
            },
            {
                condition: sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.END_TIME,
                className: 'width-50-right'
            },
            {
                condition:
                    sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.DURATION &&
                    ticketMetaData?.telephoneType === Constant.TICKET_PROPERTY.TRAINING,
                className: 'width-50-right'
            }
        ];
        return classConditions
            .filter(({ condition }) => condition)
            .map(({ className }) => className)
            .join(' ');
    };

    return (
        <div className={`form-addTicket ${getWrapperClassName()}`}>
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? 
                    <RenderTooltipTitles {...props}/> :
                    <label className="form-addTicket-label w-f100">{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                }
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            style={{paddingTop: '10px'}}
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
            
            <div className="form-addTicket-input">{getComponentPicker()}</div>
        </div>
    );
}
